import React, { useEffect, useRef } from 'react';
import * as pdfjsLib from "pdfjs-dist";

const PDFViewer = ({ fileURL, pageRange, style }) => {
  const containerRef = useRef(null);

  pdfjsLib.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.mjs";

  useEffect(() => {
    const loadPDF = async () => {
      // Clear any previous canvases
      if (containerRef.current) {
        containerRef.current.innerHTML = '';
      }

      try {
        const pdfPath = fileURL;
        const loadingTask = pdfjsLib.getDocument(pdfPath);
        const pdfDocument = await loadingTask.promise;

        const numPages = pdfDocument.numPages;
        const startPage = pageRange?.[0] || 1;
        const endPage = pageRange?.[1] || numPages;

        for (let pageNum = startPage; pageNum <= endPage; pageNum++) {
          const pdfPage = await pdfDocument.getPage(pageNum);

          const viewport = pdfPage.getViewport({ scale: 1.0 });

          // Create a new canvas for each page
          const canvasWrapper = document.createElement('div');
          canvasWrapper.style.position = 'relative';
          canvasWrapper.style.marginBottom = '30px';
          canvasWrapper.style.padding = '10px';
          canvasWrapper.style.backgroundColor = '#fff';
          canvasWrapper.style.boxShadow = '0px 4px 10px rgba(0, 0, 0, 0.2)';
          canvasWrapper.style.borderRadius = '5px';

          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          canvas.width = viewport.width;
          canvas.height = viewport.height;

          // Create a page number label
          const pageNumberLabel = document.createElement('div');
          pageNumberLabel.textContent = `Page ${pageNum}`;
          pageNumberLabel.style.position = 'absolute';
          pageNumberLabel.style.bottom = '5px';
          pageNumberLabel.style.right = '10px';
          pageNumberLabel.style.backgroundColor = 'rgba(255, 255, 255, 0.7)';
          pageNumberLabel.style.padding = '2px 5px';
          pageNumberLabel.style.borderRadius = '3px';
          pageNumberLabel.style.fontSize = '12px';

          containerRef.current.appendChild(canvasWrapper);
          canvasWrapper.appendChild(canvas);
          canvasWrapper.appendChild(pageNumberLabel);

          const renderTask = pdfPage.render({
            canvasContext: ctx,
            viewport,
          });

          await renderTask.promise;
        }
      } catch (error) {
        console.error('Error rendering PDF:', error);
      }
    };

    loadPDF();
  }, [fileURL, pageRange]);

  return (
    <div
      ref={containerRef}
      style={{
        ...style,
        border: '1px solid black',
        overflowY: 'auto',
        height: '500px',
        padding: '20px',
        backgroundColor: '#f0f0f0',
      }}
    ></div>
  );
};

export default PDFViewer;
